<template>
	<div :class="getCssClass">
		<slot></slot>

		<template v-if="isNextButtonActive">
			<div class="d21-next">
				<button class="btn btn-primary" @click="onButtonClick" :disabled="!isValid">
					<span class="mdl-m--hidden">{{hiddenText}}</span>
					<span class="mdl-m--shown">{{ shownText}}</span>
				</button>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		name: "d21-bottom-nav",
		props: {
			isNextButtonActive: Boolean,
			isValid: Boolean,
			hiddenText: String,
			shownText: String,
			cssClass: String
		},
		computed: {
			getCssClass() {
				return `d21-fixed-nav bottom ${this.cssClass}`.trim();
			}
		},
		methods: {
			onButtonClick() {
				this.$emit("next");
			}
		}
	}
</script>